var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" 予期せぬエラーが発生しました。"),_c('br'),_c('a',{attrs:{"href":"./"}},[_vm._v("ログイン画面に戻る")]),_c('br')])
}]

export { render, staticRenderFns }